import type { types } from "@fraction/shared";
import { Mail } from "lucide-react";
import { useCallback } from "react";
import { unescapeHtml } from "src/hooks/useEmailContent";
import { NotificationCardLayout } from "./NotificationCardLayout";

export interface ReplyToEmailArgs {
  communicationId: string;
  applicationId: string;
  applicationEid?: string;
  applicantNames?: string;
  subject?: string;
  senderEmail?: string;
}

export function EmailReceivedCard({
  notification,
  onDismiss,
  onReplyToEmail,
  count,
}: {
  notification: types.EmailReceivedNotification;
  onDismiss: () => void;
  onReplyToEmail: (args: ReplyToEmailArgs) => void;
  count?: number;
}) {
  const handleClick = useCallback(() => {
    onReplyToEmail({
      communicationId: notification.communicationId,
      applicationId: notification.applicationId,
      applicationEid: notification.applicationEid,
      applicantNames: notification.applicantNames,
      subject: notification.subject,
      senderEmail: notification.senderEmail,
    });
    onDismiss();
  }, [onReplyToEmail, notification, onDismiss]);

  return (
    <NotificationCardLayout
      icon={Mail}
      iconBg="bg-blue-100"
      iconColor="text-blue-600"
      title="New email"
      applicationEid={notification.applicationEid}
      applicantNames={notification.applicantNames}
      onClick={handleClick}
      count={count}
    >
      <p className="truncate text-sm font-semibold text-foreground">{notification.subject}</p>
      <p className="truncate text-xs text-muted-foreground">From {notification.senderEmail}</p>
      {notification.preview && (
        <p className="mt-0.5 line-clamp-2 text-xs text-muted-foreground/70">
          {unescapeHtml(notification.preview)}
        </p>
      )}
    </NotificationCardLayout>
  );
}
